/** Helpers to enter time as hours + minutes but store it as decimal hours
 *  (the backend multiplies decimal hours × rate). Kept at 4 dp so minutes
 *  convert cleanly, e.g. 20h 2m → "20.0333". */

/** Combine hours + minutes into a decimal-hours string (4 dp). */
export function toDecimalHours(hours: string | number, minutes: string | number): string {
  const h = Number(hours) || 0;
  const m = Number(minutes) || 0;
  return (h + m / 60).toFixed(4);
}

/** Split a decimal-hours value back into whole hours + minutes (0–59). */
export function splitHours(decimalHours: string | number | null | undefined): {
  hours: string;
  minutes: string;
} {
  const n = Number(decimalHours) || 0;
  const h = Math.floor(n);
  const m = Math.round((n - h) * 60);
  // Rounding can push minutes to 60 (e.g. 0.999h) — carry into the hour.
  if (m === 60) return { hours: String(h + 1), minutes: '0' };
  return { hours: String(h), minutes: String(m) };
}

/** Line units whose quantity is hours — rendered "Hh Mm" instead of a decimal.
 *  Mirrors the backend HOUR_UNITS. */
export const HOUR_UNITS = new Set(['hour', 'hourly']);

/** Render decimal hours as "Hh Mm" (e.g. 10.2833 → "10h 17m", 10 → "10h"). */
export function formatHoursMinutes(decimalHours: string | number | null | undefined): string {
  const { hours, minutes } = splitHours(decimalHours);
  return Number(minutes) ? `${hours}h ${minutes}m` : `${hours}h`;
}
